import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMember = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M19 17.0213V19.9021C19 20.1444 18.8062 20.3436 18.5639 20.3436H5.43616C5.19385 20.3436 5 20.1444 5 19.9021V17.0213C5 14.6952 8.13386 12.8105 12 12.8105C15.8662 12.8105 19 14.6952 19 17.0213Z",
		stroke: "#2C2C27",
		strokeMiterlimit: 10,
		strokeLinecap: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M11.9997 11.1947C14.0814 11.1947 15.769 9.50719 15.769 7.42549C15.769 5.3438 14.0814 3.65625 11.9997 3.65625C9.91802 3.65625 8.23047 5.3438 8.23047 7.42549C8.23047 9.50719 9.91802 11.1947 11.9997 11.1947Z",
		stroke: "#2C2C27",
		strokeMiterlimit: 10,
		strokeLinecap: "round"
	})]
});
export default SvgMember;
